import OnbordingComponent from '../../components/onbording/OnbordingComponent';
import { AppActions } from '../../redux/AppActions';
import { FC, useEffect } from 'react';
import { useAppDispatch } from '../../redux/store';

const OnbordingPage: FC = () => {
	const dispatch = useAppDispatch();
	const setShowNavbar = (show: boolean) => dispatch(AppActions.showNavbar(show));
	useEffect(() => {
		setShowNavbar(false);
		return () => {
			setShowNavbar(true);
		};
	}, []);
	return <OnbordingComponent />;
};

export default OnbordingPage;
